<template>
  <div class="input-panel-box">
    <el-popover ref="popover" 
                :placement="placement" 
                :popper-options="popperOptions" 
                :width="popoverWidth" 
                :trigger="trigger" 
                v-model="popoverState" 
                @show="popoverShow"  
                :visible-arrow="false">
      <slot></slot>
      <div class="footer" v-if="footerBtn">
          <el-button @click="popoverState=false">取 消</el-button>
          <el-button type="primary" @click="popoverEnter">确定</el-button>
      </div>
      <div class="close-btn" v-if="isShowClose" @click.prevent="popoverState = false">
        关闭
      </div>
      <div slot="reference">
          <slot name="reclick"></slot>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  props:{
    disabled:{
      type:Boolean,
      default:false
    },
    trigger:{
      type:String,
      default:"focus"
    },
    footerBtn:{
      type:Boolean,
      default:false,
    },
    placement:{
      type:String,
      default:"bottom-start",
    },
    popoverWidth: {
      type: Number,
      default: 537
    },
    width:{
      type:String,
      default:"100%"
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    popperOptions: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      popoverState:false,
      input: null,
    };
  },
  watch:{
    disabled(val){
      this.popoverState=false
    }
  },
  computed: {},
  methods: {
    popoverEnter(){
       this.popoverState=false
      this.$emit("popoverEnter")
    },
    popoverShow() {
      this.$emit("show");
    }
  },
  created() {},
  mounted() {
  },
};
</script>
<style scoped lang='less'>
.el-popover{
  .footer{
    text-align: right;
    margin: 10px 10px 10px 0;
  }

  .close-btn {
    margin-top: 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 36px;
    line-height: 36px;
    background-color: rgba(24, 148, 246, 0.1);
    color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cloud-clinic/components/InputPanel.vue